import moment from 'moment';
//import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';
import { excelParser } from "./excel-parser";
export default {
    name: 'Courses',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();

        if (this.loginDetails) {
            if (this.loginDetails.userType != 1)
                this.logout();
        } else {
            this.logout();
        }

        this.GetInfo();
        this.GetAllPaymentMethods();
        this.GetAllFinancialsWithdrawing();
        this.GetAllInstructors();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    filters: {
        moment: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('DD/MM/YYYY');
        },

        momentTime: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('DD/MM/YYYY || HH:MM');
        }
    },
    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',

            ScreenTitle: '  حركات المحافظ ',
            ScreenTitleSingle: '  حركة   ',
            ScreenTitleSingleAl: ' حركة  ',

            Info: [],
            Statistics: [],

            AddDialog: false,

            SelectedItem: '',

            From: '',
            To:'',
            FilterBy:1,
            PaymentMethodsId:'',
            WithdrawingId:'',
            Operation:'',
            InstructorUserId:'',

            ruleForm: {
                Id: '',
                Name: '',
                Descriptions: '',
                Image: '',
                ImageName: '',
            },
            rules: {
                Name: this.$helper.Required(),
            },
        };
    },



    methods: {

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (this.From)
                this.From = this.ChangeDate(this.From);

            if (this.To)
                    this.To = this.ChangeDate(this.To);

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetWithdrawingTracker(this.pageNo, this.pageSize, this.Search, this.From, this.To,
                this.PaymentMethodsId, this.WithdrawingId, this.Operation, this.InstructorUserId)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },


        ChangeFilter(id) {
            this.FilterBy = id;
            this.PaymentMethodsId = '';
            this.WithdrawingId = '';
            this.Operation = '';
            this.InstructorUserId = '';
        },


        Refresh() {
            this.PaymentMethodsId = '';
            this.WithdrawingId = '';
            this.Operation = '';
            this.InstructorUserId = '';
            this.From = '';
            this.To = '';
            this.GetInfo();
        },


        ExportData() {
            const s = this.Statistics;

            let dataModefide = [{
                'إجمالي قيمة الإشتراكات ': s.studentCash,
                'إجمالي قيمة المحافظ ': s.wallet,
                'إجمالي حصة المدربين': s.instructorCash,
                'إجمالي حصة المدربين / المدفوع ': s.instructorSahep,
                'إجمالي حصة المدربين / المتبقي  ': s.instructorCash - s.instructorSahep,
                'صافي المنصة ': s.studentCash - s.instructorCash,
                'صافي المنصة / المستلم ': s.edaa,
                'صافي المنصة / المتبقي ': s.studentCash - s.instructorCash - s.edaa,
                ' عدد الحركات ': s.count,
                ' قيمة السحوبات': s.sahep,
                ' قيمة الايداع': s.edaa,
                ' عدد العمليات المحذوفة': s.deleted,
            }];

            //excelParser().exportDataFromJSON(dataModefide, moment(this.From), null);
            excelParser().exportDataFromJSON(
                dataModefide,
                `تقرير_من_${this.From}_إلى_${this.To}`,
                'xls'
            );
        },

    }
}
